"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var TabEditorContainer_1 = require("../../../../../../../../shared/components/containers/TabEditorContainer");
var BrandSmsTemplateEditor = /** @class */ (function (_super) {
    __extends(BrandSmsTemplateEditor, _super);
    function BrandSmsTemplateEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        return _this;
    }
    BrandSmsTemplateEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record != null) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    sms_action_code: _item.sms_action_code,
                    sms_action_title: _item.sms_action_title,
                    description: _item.description,
                    tabKey: this.key_main,
                    app_language_id: _item.app_language_id,
                    app_language_title: _item.app_language_title,
                    _actions: [],
                    _langs: [],
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Шаблоны бренда", "Редактирование шаблона бренда"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                description: "",
                sms_action_title: "",
                sms_action_code: 0,
                tabKey: this.key_main,
                app_language_id: 0,
                app_language_title: "",
                _actions: [],
                _langs: [],
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Шаблоны бренда", "Создание шаблона бренда"]);
            });
        }
        this.SID_TACT = this.props.listSmsTemplateActions.Subscribe("*", function (id, data) {
            _this.setState({
                _actions: data.data
            });
        });
        this.SID_LANG = this.props.langsAvail.Subscribe("*", function (id, data) {
            _this.setState({
                _langs: data.data
            });
        });
        this.props.listSmsTemplateActions.LoadData();
        this.props.langsAvail.LoadData();
        this.doReSetRules();
    };
    BrandSmsTemplateEditor.prototype.componentWillUnmount = function () {
        this.props.listSmsTemplateActions.UnSubscribe(this.SID_TACT);
        this.props.langsAvail.UnSubscribe(this.SID_LANG);
    };
    BrandSmsTemplateEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            sms_action_rules: { isError: false },
            app_language_rules: { isError: false },
        });
    };
    BrandSmsTemplateEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        //if ((!this.state.header_text) || (this.state.header_text.length === 0)) {
        //    this.setState({ header_text_rules: { isError: true, errorMessage: "Поле [заголовок] не заполнено!" } })
        //    return false;
        //}
        if ((this.state.sms_action_code <= 0) || (this.state.sms_action_title.length === 0)) {
            this.setState({ sms_action_rules: { isError: true, errorMessage: "Тип действия шаблона не выбран!" } });
            return false;
        }
        if ((this.state.app_language_id <= 0) || (this.state.app_language_title.length === 0)) {
            this.setState({ app_language_rules: { isError: true, errorMessage: "Язык шаблона не выбран!" } });
            return false;
        }
        return true;
    };
    BrandSmsTemplateEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditGwsSmsTemplate({
                key: this.props.record.key,
                description: this.state.description,
                title: this.state.title,
                sms_action_code: this.state.sms_action_code,
                app_language_id: this.state.app_language_id,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Шаблон емэйл сообщения изменен!");
            });
        }
    };
    BrandSmsTemplateEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddGwsSmsTemplate({
                brand_id: this.props.rootRecord.key,
                title: this.state.title,
                description: this.state.description,
                sms_action_code: this.state.sms_action_code,
                app_language_id: this.state.app_language_id,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Шаблон емэйл сообщения создан!");
            });
        }
    };
    BrandSmsTemplateEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandSmsTemplateEditor.prototype.getFormTitle = function () {
        if (this.props.record == null) {
            return "Новый sms шаблон";
        }
        else {
            return "Изменить sms шаблон";
        }
    };
    BrandSmsTemplateEditor.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", { style: {
                minHeight: "500px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start"
            } },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип действия:", placeholder: "Выберите тип действия" }, value: { key: this.state.sms_action_code, value: this.state.sms_action_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        sms_action_code: newVal.key,
                        sms_action_title: newVal.value,
                        sms_action_rules: { isError: false }
                    });
                }, items: this.state._actions, required: true, rules: this.state.sms_action_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык шаблона:", placeholder: "Выберите язык шаблона" }, value: { key: this.state.app_language_id, value: this.state.app_language_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_language_id: newVal.key,
                        app_language_title: newVal.value,
                        app_language_rules: { isError: false }
                    });
                }, items: this.state._langs, required: true, rules: this.state.app_language_rules }),
            React.createElement("div", { style: { minHeight: "43px" } }),
            this.getDownButtons()));
    };
    BrandSmsTemplateEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BrandSmsTemplateEditor.prototype.onTabChange = function (key) {
        this.setState({ tabKey: key });
    };
    BrandSmsTemplateEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainEditContent();
        }
        return null;
    };
    BrandSmsTemplateEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 580, activeTabKey: this.state.tabKey, tabs: [
                { key: this.key_main, tab: "Основные" },
            ], onTabChange: function (key) { _this.onTabChange(key); } }, this.getContent()));
    };
    return BrandSmsTemplateEditor;
}(React.Component));
exports.default = BrandSmsTemplateEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/sms/BrandSmsTemplateEditor.tsx
// module id = 1791
// module chunks = 0